/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useMemo, useState, useCallback, useEffect} from 'react';
// material
import SelectableList from '@insticator/insticator-ui/dist/material/list/selectablelist/selectablelist';
// styles
import injectSheet from 'react-jss';
import styles from './filtersholder_styles';
import {EmojiCategories} from "../emojiList";

const filterName = 'category'

/* ========== ~~~~~~~~~~ EXPORT :  MENU : FILTER : HOLDER ~~~~~~~~~~ ========== */
export default injectSheet(styles)((props) => {
  const {
    onSelect,
    filters,
    filterState: {
      categories: selectedCategories = []
    } = {},
  } = props;

  const [isSelectAll, setIsSelectAll] = useState(false);

  useEffect(() => {
    const isSelectAll = selectedCategories.length === EmojiCategories.length;
    setIsSelectAll(isSelectAll);
  }, [selectedCategories]);

  const selected = useMemo(() => isSelectAll
      ? [...selectedCategories, 'ALL']
      : selectedCategories
    , [isSelectAll, selectedCategories]);

  const handleChange = useCallback((filterName, value) => {
    if (value === 'ALL') {
      const categories = isSelectAll
        ? EmojiCategories
        : EmojiCategories.filter(category => !selectedCategories.includes(category))
      categories.map(category => {
          // should be with setTimeout
          setTimeout(() => onSelect(filterName, category), 50)
        })
    } else {
      onSelect(filterName, value)
    }
  }, [onSelect, isSelectAll, selectedCategories]);

  return (
    <div className={`filterholder ${props.classes.filterholder} menuitems`}>
      <div className={'carrot'}/>
      <div className={'inner'}>
        {Object.keys(filters).map(filterName =>
          <SelectableList
            key={filterName}
            name={filterName}
            type={'checkbox'}
            selected={selected}
            items={[{value: 'ALL', text: 'ALL'}, ...filters[filterName].items]}
            handleChange={(value) => handleChange(filterName, value)}
          />
        )}
      </div>
    </div>
  )
});
